export default {"src":"/_next/static/media/ic-support_agent.413e2a87.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};